import { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { timerState } from "../store";

const useTimer = (initialTimeMs: any) => {
  const [timeLeft, setTimeLeft] = useState(initialTimeMs);
  const [isActive, setIsActive] = useRecoilState(timerState);

  useEffect(() => {
    let timer: any;
    if (isActive && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime: any) => prevTime - 1000);
      }, 1000);
    } else if (timeLeft <= 0) {
      setIsActive(false);
    }

    return () => clearInterval(timer);
  }, [isActive, timeLeft]);

  const formatTime = (ms: any) => {
    const totalSeconds = Math.max(Math.floor(ms / 1000), 0);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n: any) => String(n).padStart(2, "0");

    return hours > 0
      ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`;
  };

  const start = () => setIsActive(true);
  const stop = () => setIsActive(false);
  const reset = () => setTimeLeft(initialTimeMs);

  return {
    timeLeft,
    formattedTime: formatTime(timeLeft),
    start,
    stop,
    reset,
  };
};

export default useTimer;
